module.exports = __webpack_public_path__ + "static/media/carta_6.7fc04f3f.jpg";